import React, { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Skeleton } from "../../Components/Needed";
import { fetchLanguages, saveLanguage } from "../../Helpers/notificationConsoleApi";

// Notification Centre > Languages (Phase 6.6). The languages messages can be written in. Each person gets
// their own language when it is switched on here, otherwise the default language, otherwise the built-in
// wording. English is always there. WhatsApp and SMS need a template approved in each language.
const LanguagesTab = () => {
    const [loading, setLoading] = useState(true);
    const [list, setList] = useState([]);
    const [code, setCode] = useState("");
    const [name, setName] = useState("");
    const [busy, setBusy] = useState(false);

    const load = useCallback(async () => {
        const result = await fetchLanguages();
        if (result.ok) setList(result.data.languages || []);
        else toast.error(result.message);
        setLoading(false);
    }, []);
    useEffect(() => { load(); }, [load]);

    const change = async (payload, done) => {
        setBusy(true);
        const result = await saveLanguage(payload);
        setBusy(false);
        if (!result.ok) return toast.error(result.message);
        toast.success(done);
        setList(result.data.languages || []);
        return true;
    };
    const add = async (e) => {
        e.preventDefault();
        if (await change({ code: code.trim().toLowerCase(), name: name.trim() }, "Language added")) { setCode(""); setName(""); }
    };

    if (loading) return <div className="settings-card"><Skeleton height={24} width="40%" className="mb-3" /><Skeleton height={160} /></div>;

    return (
        <div className="settings-card">
            <h5 className="fw-semibold mb-1">Languages</h5>
            <p className="text-muted small mb-3">Each customer, admin and staff member gets messages in their own language when it is on here, otherwise in the default language. Write the wording for a language in Messages or the Library.</p>
            <div className="nc-table-wrap">
                <table className="table table-sm nc-table">
                    <thead><tr><th>Language</th><th>Code</th><th>On</th><th>Default</th></tr></thead>
                    <tbody>
                        {list.map((l) => (
                            <tr key={l.code}>
                                <td className="fw-semibold">{l.name}</td>
                                <td className="nc-mono">{l.code}</td>
                                <td>
                                    <div className="form-check form-switch m-0">
                                        <input className="form-check-input" type="checkbox" aria-label={`${l.name} on`} checked={l.enabled} disabled={busy || l.code === "en" || l.isDefault} onChange={() => change({ code: l.code, enabled: !l.enabled }, `${l.name} switched ${l.enabled ? "off" : "on"}`)} />
                                    </div>
                                </td>
                                <td>
                                    {l.isDefault ? <span className="nc-tag nc-tag-lock">Default</span> : <button type="button" className="btn btn-outline-secondary btn-sm" disabled={busy || !l.enabled} onClick={() => change({ code: l.code, isDefault: true }, `${l.name} is now the default`)}>Make default</button>}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <form className="d-flex flex-wrap gap-2 align-items-end mt-3" onSubmit={add}>
                <div><label className="form-label small mb-1" htmlFor="lang-code">Code</label><input id="lang-code" className="form-control form-control-sm" placeholder="ta" value={code} maxLength={8} onChange={(e) => setCode(e.target.value)} /></div>
                <div><label className="form-label small mb-1" htmlFor="lang-name">Name</label><input id="lang-name" className="form-control form-control-sm" placeholder="Tamil" value={name} maxLength={40} onChange={(e) => setName(e.target.value)} /></div>
                <button type="submit" className="btn btn-primary btn-sm" disabled={busy || !code.trim() || !name.trim()}>Add language</button>
            </form>
        </div>
    );
};

export default LanguagesTab;
